/** Bump when content changes (server ETag + client cache). v1 pack = 2, v2 pack = 3 (docs/CURRICULUM-V2.md §F). */
export const CONTENT_VERSION = 2;
export const CONTENT_VERSION_V2 = 3;
